 const ShowItemContent = (item, isGroupNote, divContent = null) => {
    if (item.IsRepeated === 'true' && item.IsGroupEncounter === 'true' && isGroupNote) {
      return item.PatientName + ' - ' + item.content || '[Enter prompt or question]'
    } else {
      if(item.name === 'Formatting Text'){
        if(divContent) return divContent;
        return <></>;
      }
      return item.content || '[Enter prompt or question]'
    }
  }

  export default ShowItemContent